<template>

<app-wrapper>

	<app-text v-html="page.customer_refer_content" />

	<app-text :spaced="true">

		<div class="code" v-if="code">{{ code }}</div>

		<app-group :row="true">

			<app-button :loading="is.generating" :text="(is.generated) ? page.customer_refer_button_generate_again : page.customer_refer_button_generate" v-on:click="onGenerateClick" />

		</app-group>

	</app-text>

</app-wrapper>

</template>

<script>

export default {

	data: function() {

		return {
			code: false,
			is: {
				generating: false,
				generated: false
			}
		}

	},
	
	methods: {

		onGenerateClick: function() {

			this.is.generating = true

			this.$api.request('account/refer').then(function(json) {

				this.code = json.code

				this.is.generating = false
				this.is.generated = true

			}.bind(this))

		}

	}

}

</script>

<style scoped>

.code {
    border: 1px dashed #eee;
    font-size: 24px;
    text-align: center;
    line-height: 46px;
    width: 300px;
    margin-bottom: 20px;
    color: #333;
    letter-spacing: 3px;
}

</style>